// signup
export const USER_SIGNUP_REQUEST = "USER_SIGNUP_REQUEST";
export const USER_SIGNUP_SUCCESS = "USER_SIGNUP_SUCCESS";
export const USER_SIGNUP_FAILURE = "USER_SIGNUP_FAILURE";
export const CHANGE_SIGNUP_VALUE = "CHANGE_SIGNUP_VALUE";

// login with password
export const USER_LOGIN_PASS_REQUEST = "USER_LOGIN_PASS_REQUEST";
export const USER_LOGIN_PASS_SUCCESS = "USER_LOGIN_PASS_SUCCESS";
export const USER_LOGIN_PASS_FAILURE = "USER_LOGIN_PASS_FAILURE";

// otplogin
export const USER_OTP_LOGIN_REQUEST = "USER_OTP_LOGIN_REQUEST";
export const USER_OTP_LOGIN_SUCCESS = "USER_OTP_LOGIN_SUCCESS";
export const USER_OTP_LOGIN_FAILURE = "USER_OTP_LOGIN_FAILURE";

// mobile save
export const USER_MOBILE_SAVE = "USER_MOBILE_SAVE";

// login otp verify
export const USER_OTP_VERIFY_FAILURE = "USER_OTP_VERIFY_FAILURE";
export const USER_OTP_VERIFY_SUCCESS = "USER_OTP_VERIFY_SUCCESS";
export const USER_OTP_VERIFY_REQUEST = "USER_OTP_VERIFY_REQUEST";

// google oauth login
export const USER_OAUTH_FAILURE = "USER_OAUTH_FAILURE";
export const USER_OAUTH_REQUEST = "USER_OAUTH_REQUEST";
export const USER_OAUTH_SUCCESS = "USER_OAUTH_SUCCESS";

// logout
export const USER_LOGOUT_REQUEST = "USER_LOGOUT_REQUEST";
export const USER_LOGOUT_SUCCESS = "USER_LOGOUT_SUCCESS";
export const USER_LOGOUT_FAILURE = "USER_LOGOUT_FAILURE";
export const CHANGE_LOGOUT_VALUE = "CHANGE_LOGOUT_VALUE";

// hotel listing
export const GET_HOTEL_LISTING_FAILURE = "GET_HOTEL_LISTING_FAILURE";
export const GET_HOTEL_LISTING_SUCCESS = "GET_HOTEL_LISTING_SUCCESS";
export const GET_HOTEL_LISTING_REQUEST = "GET_HOTEL_LISTING_REQUEST";

// hotel filtering
export const HANDLE_FILTER_AMENITIES = "HANDLE_FILTER_AMENITIES";
export const HANDLE_FILTER_COLLECTIONS = "HANDLE_FILTER_COLLECTIONS";
export const HANDLE_FILTER_CATEGORY = "HANDLE_FILTER_CATEGORY";
export const HANDLE_FILTER_CHECKIN = "HANDLE_FILTER_CHECKIN";
export const HANDLE_FILTER_ACCOMODATION = "HANDLE_FILTER_ACCOMODATION";
export const HANDLE_PARAMS = "HANDLE_PARAMS";

// hotel entity
export const HOTEL_ENTITY_REQUEST = "HOTEL_ENTITY_REQUEST";
export const HOTEL_ENTITY_SUCCESS = "HOTEL_ENTITY_SUCCESS";
export const HOTEL_ENTITY_FAILURE = "HOTEL_ENTITY_FAILURE";
// hotel id
export const HOTEL_ID = "HOTEL_ID";
// hotel data page
export const PAGE_CHANGE = 'PAGE_CHANGE';
// hotel bill data
export const HOTEL_BILLING_REQUEST = "HOTEL_BILLING_REQUEST";
export const HOTEL_BILLING_SUCCESS = "HOTEL_BILLING_SUCCESS";
export const HOTEL_BILLING_FAILURE = "HOTEL_BILLING_FAILURE";
// hotel recommendation
export const HOTEL_RECOMMENDATION_REQUEST = "HOTEL_RECOMMENDATION_REQUEST";
export const HOTEL_RECOMMENDATION_SUCCESS = "HOTEL_RECOMMENDATION_SUCCESS";
export const HOTEL_RECOMMENDATION_FAILURE = "HOTEL_RECOMMENDATION_FAILURE";
// hotel review
export const HOTEL_REVIEW_REQUEST = "HOTEL_REVIEW_REQUEST";
export const HOTEL_REVIEW_SUCCESS = "HOTEL_REVIEW_SUCCESS";
export const HOTEL_REVIEW_FAILURE = "HOTEL_REVIEW_FAILURE";
//razor pay request
export const RAZORPAY_REQUEST_REQUEST = "RAZORPAY_REQUEST_REQUEST";
export const RAZORPAY_REQUEST_SUCCESS = "RAZORPAY_REQUEST_SUCCESS";
export const RAZORPAY_REQUEST_FAILURE = "RAZORPAY_REQUEST_FAILURE";

